var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-box"},[_c('span',{staticClass:"no_wrap"},[_c('span',{staticClass:"no_data"},[_c('img',{attrs:{"src":require("@/assets/images/no_data.png")}}),_c('p',{staticClass:"no_data_text"},[_vm._v("暂无数据")])])])])
}]

export { render, staticRenderFns }